import React, { useState, useEffect } from "react";
import TextField from "../../../components/inputs/textfield";
import { FaSearch } from "react-icons/fa";
import { resourcePersonalList } from "../user.api";
import "./style.css";
import "../../public/advisors/style.css";
import Loader from "../../../components/loader/loader";
import BreadCrumpBack from "../../../components/navigator/back";

export default function ResPerList(props) {
  const [searchData, setSearchData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const isLoggedInCheck = Boolean(
    props?.state?.payload ||
    localStorage.getItem("token") ||
    localStorage.getItem("payload") ||
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("payload")
  );

  useEffect(() => {
    setIsLoggedIn(isLoggedInCheck);
  }, [isLoggedInCheck]);

  const listData = () => {
    resourcePersonalList().then((res) => {
      let dir = res.data;
      let finalData = [];
      dir.forEach((item) => {
        if (
          // item.expert_manpower?.is_resource_person === 1 &&
          item?.approval_status === 2
        ) {
          finalData.push(item);
        }
      });
      setIsActive(false);

      setSearchData(finalData);

      setIsActive(false);
    });
  };

  useEffect(() => {
    listData();
  }, []);

  // Normalize tile heights per row so "View More" aligns across a row
  useEffect(() => {
    const alignPerRow = () => {
      try {
        const container = document.querySelector(
          ".org-sub-containers"
        );
        if (!container) return;
        const tiles = Array.from(
          container.querySelectorAll(".core-item .tile-body")
        );
        // Reset heights first
        tiles.forEach((el) => (el.style.minHeight = ""));
        // Group by rows based on offsetTop
        const rows = {};
        tiles.forEach((el) => {
          const top = el.parentElement.parentElement.offsetTop; // core-item > (tile-body's parent) is core-item > tile-body
          rows[top] = rows[top] || [];
          rows[top].push(el);
        });
        Object.values(rows).forEach((rowEls) => {
          const maxH = Math.max(
            ...rowEls.map((el) => el.getBoundingClientRect().height)
          );
          rowEls.forEach((el) => (el.style.minHeight = `${Math.ceil(maxH)}px`));
        });
      } catch (e) {
        // silent
      }
    };

    // Align after DOM updates
    const t = setTimeout(alignPerRow, 0);
    window.addEventListener("resize", alignPerRow);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", alignPerRow);
    };
  }, [searchData, isLoggedIn]);

  return (
    <div className="tender bg-tender">
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "റിസോഴ്സ് പേഴ്‌സണൽ"
              : "Resource Personnel"}
          </div>
        </div>
        <BreadCrumpBack />
      </div>
      <div className="container p-50">
        <div className="res-page-cont">
          <div className="row tender-box">
            <div className="new-res-tile-cont-res">
              {searchData.length !== 0 ? (
                <div className="container adbox mt-3">
                  <div className="org-sub-containers row row-cols-1 row-cols-md-2 row-cols-lg-3">
                    {searchData?.map((item) => (
                      <div key={item.user_id} className="core-item col d-flex">
                        <div className="tile-body d-flex flex-column p-2 w-100">
                          <div className="d-flex justify-content-center">
                            <img
                              className="org-avatar"
                              src={`${result}${item?.file_upload}`}
                              alt=""
                            />
                          </div>
                          <div className="org-title">{`${item?.title} . ${item?.first_name} ${item?.last_name}`}</div>
                          <div className="org-designation">
                            {item?.current_designation_organization || ""}
                          </div>
                          {isLoggedIn && (
                            <div className="mt-auto d-flex justify-content-center">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => props.history.push(`/resource-personal/${item?.user_id}`)}
                              >
                                View More
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
